import { InputAdornment, MenuItem, Select } from "@mui/material";
import { POSITION_OPTIONS } from "../../../enums/recruitment";

function FilterPosition({ value, onChange }) {
  return (
    <Select
      value={value}
      fullWidth
      onChange={(event) => onChange(+event.target.value)}
      sx={{ "&.MuiOutlinedInput-root ": { borderRadius: 2 } }}
      startAdornment={
        <InputAdornment position="start">
          <img src="/assets/icons/ic_shopping_bag.svg" className="w-5 h-5" />
        </InputAdornment>
      }
    >
      {POSITION_OPTIONS.map((item) => (
        <MenuItem key={item.value} value={item.value}>
          {item.title}
        </MenuItem>
      ))}
    </Select>
  );
}

export default FilterPosition;
